import * as React from "react"
import { VictoryPie } from "victory-pie"
import { VictoryTooltip } from "victory-tooltip"
import { theme } from "../../theme"

interface PieChartProps {
  data: Array<any>
  onHoverPie?: (index?: number) => void
}

export const ChartsColorScale = [
  "#E9F1FA",
  "#E1EAF4",
  "#C5D3E0",
  "#B8C7D6",
  "#A7B7C7",
  "#97A7B7",
  "#8191A1",
  "#6D7D8D",
  "#506172",
  "#394756",
]

const PieChart: React.FunctionComponent<PieChartProps> = ({ data, onHoverPie }) => {
  const onHover = (index: undefined | number) => {
    onHoverPie && onHoverPie(index)
  }

  return (
    <VictoryPie
      data={data}
      colorScale={ChartsColorScale}
      style={{ labels: { color: "fill", fontSize: 10 } }}
      labelComponent={
        <VictoryTooltip
          flyoutStyle={{
            fill: theme.colors.yellow,
            opacity: 0.8,
            stroke: "1px solid white",
            color: theme.colors.white,
            fontSize: 12,
          }}
        />
      }
      events={[
        {
          target: "data",
          eventHandlers: {
            onMouseOver: (event, data) => {
              onHover(data.index)
              return [
                {
                  target: "data",
                  mutation: () => ({
                    style: { fill: theme.colors.yellow },
                  }),
                },
                {
                  target: "labels",
                  mutation: () => ({
                    active: true,
                    style: { fill: theme.colors.greyDark, fontSize: 12 },
                  }),
                },
              ]
            },
            onMouseOut: () => {
              onHover(undefined)
              return [
                {
                  target: "data",
                  mutation: () => {},
                },
                {
                  target: "labels",
                  mutation: () => ({ active: false }),
                },
              ]
            },
          },
        },
      ]}
    />
  )
}

export default PieChart
